var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "green-border-box in-padd white-bg" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12" }, [
        _c(
          "button",
          {
            staticClass: "btn-lg-grey",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.$router.push("/brand/links")
              }
            }
          },
          [_vm._v("\n        Back to Links\n      ")]
        )
      ])
    ]),
    _vm.loading
      ? _c("div", { staticClass: "text-center mt20" }, [
          _vm._v("Loading link...")
        ])
      : _c(
          "form",
          {
            staticClass: "mt15",
            attrs: { "data-vv-scope": "edit-link-form" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.saveLink($event)
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                  _c(
                    "label",
                    {
                      staticClass: "block mb5",
                      attrs: { for: "edit-link-type" }
                    },
                    [_vm._v("Link Type")]
                  ),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.link_type,
                          expression: "form.link_type"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      class: {
                        input: true,
                        "is-danger": _vm.errors.has("edit-link-form.link_type")
                      },
                      attrs: { id: "edit-link-type", name: "link_type" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.form,
                            "link_type",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v("Select link type...")
                      ]),
                      _c("option", { attrs: { value: "app-install" } }, [
                        _vm._v("App Install (apple/google play)")
                      ]),
                      _c("option", { attrs: { value: "review" } }, [
                        _vm._v("Review (external link)")
                      ])
                    ]
                  ),
                  _vm.errors.has("edit-link-form.link_type")
                    ? _c("span", { staticClass: "error-msg" }, [
                        _vm._v(
                          _vm._s(_vm.errors.first("edit-link-form.link_type"))
                        )
                      ])
                    : _vm._e()
                ]),
                _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                  _c(
                    "label",
                    {
                      staticClass: "block mb5",
                      attrs: { for: "edit-link-title" }
                    },
                    [_vm._v("Title")]
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.title,
                        expression: "form.title"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "input",
                    class: {
                      input: true,
                      "is-danger": _vm.errors.has("edit-link-form.title")
                    },
                    attrs: {
                      id: "edit-link-title",
                      name: "title",
                      type: "text",
                      placeholder: "Title",
                      maxlength: "255"
                    },
                    domProps: { value: _vm.form.title },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "title", $event.target.value)
                      }
                    }
                  }),
                  _vm.errors.has("edit-link-form.title")
                    ? _c("span", { staticClass: "error-msg" }, [
                        _vm._v(_vm._s(_vm.errors.first("edit-link-form.title")))
                      ])
                    : _vm._e()
                ]),
                _c("div", { staticClass: "col-xs-12 mt10" }, [
                  _c(
                    "label",
                    {
                      staticClass: "block mb5",
                      attrs: { for: "edit-link-desc" }
                    },
                    [_vm._v("Description")]
                  ),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.description,
                        expression: "form.description"
                      }
                    ],
                    staticClass: "input textarea",
                    attrs: {
                      id: "edit-link-desc",
                      placeholder: "Description",
                      rows: "3",
                      maxlength: "500"
                    },
                    domProps: { value: _vm.form.description },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "description", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm.form.link_type === "watch" ||
                _vm.form.link_type === "review"
                  ? [
                      _c("div", { staticClass: "col-xs-12 mt10" }, [
                        _c(
                          "label",
                          {
                            staticClass: "block mb5",
                            attrs: {
                              for: "edit-link-website-" + _vm.form.link_type
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.form.link_type === "watch"
                                  ? "Video / Website URL"
                                  : "Review URL"
                              )
                            )
                          ]
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.website_link,
                              expression: "form.website_link"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: true,
                                url: { require_protocol: true }
                              },
                              expression:
                                "{ required: true, url: { require_protocol: true } }"
                            }
                          ],
                          class: {
                            input: true,
                            "is-danger": _vm.errors.has(
                              "edit-link-form.website_link"
                            )
                          },
                          attrs: {
                            id: "edit-link-website-" + _vm.form.link_type,
                            name: "website_link",
                            type: "text",
                            placeholder:
                              _vm.form.link_type === "watch"
                                ? "e.g. https://youtube.com/..."
                                : "e.g. https://..."
                          },
                          domProps: { value: _vm.form.website_link },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "website_link",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm.errors.has("edit-link-form.website_link")
                          ? _c("span", { staticClass: "error-msg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errors.first(
                                    "edit-link-form.website_link"
                                  )
                                )
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  : _vm._e(),
                _vm.form.link_type === "app-install"
                  ? [
                      _c("div", { staticClass: "col-xs-12 mt10" }, [
                        _c(
                          "label",
                          {
                            staticClass: "block mb5",
                            attrs: { for: "edit-link-ios" }
                          },
                          [_vm._v("iOS App Store Link")]
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.ios_link,
                              expression: "form.ios_link"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { url: { require_protocol: true } },
                              expression: "{ url: { require_protocol: true } }"
                            }
                          ],
                          class: {
                            input: true,
                            "is-danger": _vm.errors.has(
                              "edit-link-form.ios_link"
                            )
                          },
                          attrs: {
                            id: "edit-link-ios",
                            name: "ios_link",
                            type: "text",
                            placeholder: "https://apps.apple.com/..."
                          },
                          domProps: { value: _vm.form.ios_link },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "ios_link",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm.errors.has("edit-link-form.ios_link")
                          ? _c("span", { staticClass: "error-msg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errors.first("edit-link-form.ios_link")
                                )
                              )
                            ])
                          : _vm._e()
                      ]),
                      _c("div", { staticClass: "col-xs-12 mt10" }, [
                        _c(
                          "label",
                          {
                            staticClass: "block mb5",
                            attrs: { for: "edit-link-android" }
                          },
                          [_vm._v("Android / Google Play Link")]
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.android_link,
                              expression: "form.android_link"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { url: { require_protocol: true } },
                              expression: "{ url: { require_protocol: true } }"
                            }
                          ],
                          class: {
                            input: true,
                            "is-danger": _vm.errors.has(
                              "edit-link-form.android_link"
                            )
                          },
                          attrs: {
                            id: "edit-link-android",
                            name: "android_link",
                            type: "text",
                            placeholder: "https://play.google.com/..."
                          },
                          domProps: { value: _vm.form.android_link },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "android_link",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm.errors.has("edit-link-form.android_link")
                          ? _c("span", { staticClass: "error-msg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errors.first(
                                    "edit-link-form.android_link"
                                  )
                                )
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm.appInstallLinkError
                        ? _c("div", { staticClass: "col-xs-12 mt10" }, [
                            _c("span", { staticClass: "error-msg" }, [
                              _vm._v(_vm._s(_vm.appInstallLinkError))
                            ])
                          ])
                        : _vm._e()
                    ]
                  : _vm._e()
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "row mt15" },
              [
                _vm._m(0),
                _c("div", { staticClass: "col-xs-12 croppa-tip" }),
                _vm._l(_vm.croppers, function(cropper, i) {
                  return _c(
                    "div",
                    {
                      key: "edit-link-image-" + i,
                      staticClass: "col-xs-12 col-sm-6 col-md-6 text-center"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "upload-remove-container" },
                        [
                          _c("croppa", {
                            attrs: {
                              placeholder: "Select Image",
                              "initial-size": "contain",
                              "placeholder-font-size": 25,
                              "show-remove-button": false,
                              "initial-image": _vm.initialImages[i]
                            },
                            model: {
                              value: _vm.croppers[i],
                              callback: function($$v) {
                                _vm.$set(_vm.croppers, i, $$v)
                              },
                              expression: "croppers[i]"
                            }
                          }),
                          _vm.croppers[i] && _vm.croppers[i].hasImage()
                            ? _c("button", {
                                staticClass: "upload-remove",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.croppers[i].remove()
                                  }
                                }
                              })
                            : _vm._e(),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.imageNames[i],
                                expression: "imageNames[i]"
                              }
                            ],
                            staticClass: "mb30 mt5",
                            attrs: {
                              type: "text",
                              placeholder: "Image title",
                              maxlength: "31"
                            },
                            domProps: { value: _vm.imageNames[i] },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(_vm.imageNames, i, $event.target.value)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                })
              ],
              2
            ),
            _c("div", { staticClass: "row mt15" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-lg-green",
                    attrs: { type: "submit", disabled: _vm.busy }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.busy ? "Saving..." : "Update Link") +
                        "\n        "
                    )
                  ]
                )
              ])
            ])
          ]
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-12" }, [
      _c("h4", { staticClass: "text-center" }, [_vm._v("Images (up to 4)")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }